import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Main from "../../components/layout/Main";
import GamesImage from "../../assets/images/games-image.jpg"; // or any image path
import { useTournament } from "../../context/TournamentContext";
import { isValidUrl } from "../../helper/functions";
import { ImageNotAvailable } from "../../constants/urls";

const AllGames = () => {
  const [games, setGames] = React.useState([]);
  const { loadGames } = useTournament();
  const navigate = useNavigate();

  const title = "Select Game Version";

  // ----------   handlers   -----------
  const fetchGames = async () => {
    const result = await loadGames();
    if (result.status === 200) {
      setGames(result.data.data.uncategorizedGames);
    }
  };

  // ---------- use effects ----------
  useEffect(() => {
    fetchGames();
  }, []);

  return (
    <Main>
      <div className="all-games-componanat">
        <div className="section-header">
          <div className="orange-header">{title}</div>
          {/* <span className="view-all" onClick={() => navigate(-1)}>
                Back
            </span> */}
        </div>

        <div className="main-grid-new">
          {games && games.length > 0 ? (
            games.map((item, index) => (
              <div
                key={index}
                className="game-card"
                onClick={() => navigate("/select-game")}
              >
                <img
                  src={
                    isValidUrl(item?.game?.image)
                      ? item?.game?.image
                      : ImageNotAvailable
                  }
                  alt={`Game ${index + 1}`}
                  className="game-image"
                />
              </div>
            ))
          ) : (
            <div className="no-games-available">
              <p>No games available</p>
            </div>
          )}
        </div>
      </div>
    </Main>
  );
};

export default AllGames;
